export default class FormField {
	static TYPE_CHECKBOX = "checkbox";

	constructor({ id, label, type, choices, removed } = {}) {
		this.id = id;
		this.label = label;
		this.type = type;
		this.choices = choices || [];
		this.removed = removed;
	}

	static buildFromJSON(json) {
		return new FormField({
			id: json.id,
			label: json.label,
			type: json.type,
			choices: json.choices || [],
			removed: json.removed
		});
	}

	toJSON() {
		return {
			id: this.id,
			label: this.label,
			type: this.type,
			choices: this.choices,
			removed: this.removed
		};
	}

	getId() {
		return this.id;
	}

	getLabel() {
		return this.label;
	}

	getType() {
		return this.type;
	}

	getChoices() {
		return this.choices;
	}

	isRemoved() {
		return this.removed;
	}
}
